<template>
  <div
    v-if="isLotProgressif || isLotProgressif == null"
    class="couleur-fond align-items-center h-100 position-relative"
    :class="typeCarte"
    :style="{ '--couleur': isProgressifColor ? progressif.couleur : '#060606' }"
  >
    <b-container
      class="banniere-progressif d-flex justify-content-center align-items-center h-100 m-auto"
      :class="grosseurCarte"
    >
      <b-row
        class="m-0 w-100 h-100 text-white"
        :class="{ 'justify-content-center': !mntProgressif }"
      >
        <b-col
          v-if="isProgressifImage"
          :cols="mntProgressif ? 4 : 12"
          class="graphik_bold d-flex align-items-center mh-100 pl-0 pr-1"
        >
          <div
            :class="{
              'h-100 w-100 d-flex justify-content-center align-items-center': !mntProgressif,
            }"
          >
            <b-img-lazy class="mh-100 mw-100" :src="jel_getFichierSrc(progressif.image)" alt="" />
          </div>
        </b-col>
        <b-col
          v-else
          :cols="mntProgressif ? 4 : 12"
          class="graphik_bold p-0 my-auto titre"
          :class="{ 'text-center': !mntProgressif }"
        >
          <div class="titre-progressif" :class="{ 'px-0': !mntProgressif }">
            <span :class="{ 'simple-ligne': !isProgressifTitre }">{{ titreLotProgressif }}</span>
          </div>
        </b-col>
        <b-col v-if="mntProgressif" cols="8" class="p-0 h-100">
          <div
            class="overflow-hidden graphik_semibold d-flex align-items-center justify-content-end montant w-100 h-100"
            :class="`montant-${$i18n.locale}`"
          >
            <div v-if="$i18n.locale == 'en'">$</div>
            <div
              v-for="(chiffre, index) in arrMntProgressif"
              :key="index"
              class="d-flex align-items-center h-100"
              :class="{ 'container-chiffre': !isNaN(chiffre) }"
            >
              <span
                :class="[
                  isNaN(chiffre)
                    ? 'pt-2'
                    : 'case-chiffre chiffre d-flex align-items-center justify-content-center w-100',
                ]"
              >
                {{ chiffre }}
              </span>
            </div>
            <div v-if="$i18n.locale == 'fr'">$</div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { formatMontant } from '@/helpers/StringHelpers';

export default {
  name: 'BanniereInfoLotProgressif',
  props: {
    content: { type: Object, required: true },
  },
  i18n: {
    messages: {
      fr: {
        messageComponent: {
          lotProgressif: 'Lot progressif | Lot progressif | Progressifs multiples',
        },
      },
      en: {
        messageComponent: {
          lotProgressif: 'Progressive Jackpot | Progressive Jackpot | Multiple Jackpots',
        },
      },
    },
  },
  data() {
    return {
      grosseurCarte: null,
      typeCarte: null,
    };
  },
  computed: {
    ...mapGetters({
      getProgressifCasinoMontant: 'progressif/getProgressifCasinoMontant',
      getProgressifByUuid: 'progressif/getByUuid',
      isProgressifLotProgressif: 'progressif/isLotProgressif',
    }),
    progressif() {
      const progressif = this.getProgressifByUuid(this.content.produit.idProgressif);

      if (!progressif) {
        // Ce cas peut survenir si le progressif a été détruit.
        // On se retrouve avec un uuid orphelin sur le produit.
        // Affiche un bandeau blanc à la place du progressif.

        console.warn(`Le produit '${this.content.produit.name}' a un progressif indéfini`);
      }

      return progressif;
    },
    isLotProgressif() {
      return this.isProgressifLotProgressif(this.progressif);
    },
    isProgressifColor() {
      return this.progressif && this.progressif.couleur;
    },
    isProgressifImage() {
      return this.progressif && this.progressif.image;
    },
    isProgressifTitre() {
      return this.progressif && this.progressif.titre;
    },
    mntProgressif() {
      return this.getProgressifCasinoMontant(this.progressif);
    },
    arrMntProgressif() {
      return [...Array.from(formatMontant(this.mntProgressif).replace(/ /g, '').replace('$', ''))];
    },
    isCarte4x3() {
      return !this.content.isListeHorizontale && this.$el.clientWidth > 450;
    },
    nbProgressif() {
      return this.content.produit.listeProgressif?.length ?? 0;
    },

    titreLotProgressif() {
      if (this.isProgressifTitre) {
        return this.progressif.titre;
      }
      return this.$i18n.tc('messageComponent.lotProgressif', this.nbProgressif);
    },
  },
};
</script>

<style lang="scss" scoped>
$facteurTaille: 1.2;

.container {
  max-width: none;
  padding: 0;
  height: 2.8rem;
}

//Fonctionne sur tous les fureteurs sauf Safari 14
@supports (aspect-ratio: 4/10) {
  .container-chiffre {
    aspect-ratio: 4/10;
  }
}

// Fonctionne sur Safari 14
@supports not (aspect-ratio: 4/10) {
  .container-chiffre {
    width: 15%;
  }
}

.couleur-fond {
  background-color: var(--couleur);
  bottom: 0;
  width: -webkit-fill-available;
}

p {
  color: black !important;
}

.montant-fr.montant {
  div:nth-last-child(3n + 1),
  div:last-child {
    margin-left: 0.25em !important;
  }
}

.titre-progressif {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  font-size: 1rem;
  line-height: 1.125rem;
  overflow: hidden;
  ::v-deep sup {
    display: inline-block;
  }
  .simple-ligne {
    display: inline-block;
  }
}

span.case-chiffre {
  height: 50%;
  padding-top: 2px;
}

span.chiffre {
  color: black;
  background: white;
  margin-left: $facteurTaille * 1px;
  margin-right: $facteurTaille * 1px;
  margin-top: 0px;
  margin-bottom: 0px;
  border-radius: $facteurTaille * 4px;
  font-weight: $facteurTaille * 600;
}
</style>
